export const getTitle = (isSubscription: boolean): string => {
  const entityName = isSubscription ? 'подписку' : 'пакет';

  return `Купить ${entityName} со скидкой`;
};
